import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import { isValidArray, normalizePath, normalizeUrlPath } from "../../Layout/Common/common";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { BrandSkeleton } from "../../Skeleton/brandSkeleton";
import { Link, useParams } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { GlobalContext } from "../../Context/GlobalContext";

export const BrandGridContainer = ({ brands, handleBrandSelected }) => {
  const [Breadcrumb, setBreadcrumb] = useState([]);
  const [manufacturer, setManufacturer] = useState(null);
  const [filterAlpha, setFilterAlpha] = useState(null);
  const [selectedAlpha, setSelectedAlpha] = useState("ALL");
  const { setBrandList, brandList } = useContext(GlobalContext);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const objectRef = useRef();
  const { brandName } = useParams();
  var data = {};
  useEffect(() => {
    if (brands) {
      setBrandList(brands);
      objectRef.current = brands;
      setAlphebetFilter(brands);
      setSelectedAlpha("ALL");
    } else {
      setBrandList(null);
      objectRef.current = null;
      setSelectedAlpha("ALL");
    }
    return () => {
      setBrandList(null);
      objectRef.current = null;
      setSelectedAlpha("ALL");
    };
  }, [brands]);

  const handleFilterAlpha = (alpha) => {
    setSelectedAlpha(alpha);
    if (alpha == "ALL") setBrandList(objectRef.current);
    else {
      let item = objectRef.current.filter((item) => String(item.brandName).toUpperCase().startsWith(alpha));
      setBrandList(item);
    }
  };

  const setAlphebetFilter = (items) => {
    try {
      let nameList = items.map((item) => item.brandName.charAt(0).toUpperCase());
      const uniqueNames = [...new Set(nameList)];
      setFilterAlpha(uniqueNames.sort((a, b) => a.localeCompare(b)));
      handleFilterAlpha("ALL");
    } catch (e) {
      console.error("e", e);
    }
  };

  const handleSearch = (e) => {
    try {
      let txt = e?.target?.value;
      let item = objectRef.current.filter((item) => String(item.brandName).toUpperCase().includes(txt.toUpperCase()));
      setAlphebetFilter(item);
      setBrandList(item);
    } catch (e) {
      console.error("e", e);
    }
  };

  return (
    <Fragment>
      <section className="brand-list-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-sm-6 col-lg-6 shop-brand-title">
              <h1>Shop By Brand</h1>
            </div>
            <div className="col-sm-6 col-lg-6">
              <div className="shop-brand-search position-relative float-end">
                <input
                  className="form-control me-2"
                  type="text"
                  name="searchbox"
                  placeholder="Search here"
                  aria-label="Search"
                  onChange={handleSearch}
                  autoComplete="off"
                />
                <span className="wes-search" />
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-12">
              <div className="brands-list">
                <ul>
                  <li>
                    <a
                      role="button"
                      onClick={() => handleFilterAlpha("ALL")}
                      className={`${selectedAlpha == "ALL" && "active"}`}
                    >
                      All
                    </a>
                  </li>
                  {filterAlpha &&
                    filterAlpha.map((item) => (
                      <li className="border-link">
                        <a
                          role="button"
                          className={`${selectedAlpha == item && "active"}`}
                          onClick={() => handleFilterAlpha(item)}
                        >
                          {item}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <TransitionGroup className={"row row-equal-coloumn"}>
            {isValidArray(brandList) ? (
              brandList.map((row, index) => (
                <CSSTransition key={row.id} timeout={500} classNames="fade">
                  <div className="col-4 col-sm-3 col-md-3 col-lg-3 mt-3 mt-lg-4">
                    <div className="branding-list">
                      <Link to={"/" + row.brandUrl} onClick={() => setSelectedBrand(row)} className="brand-list-effect">
                        <ImageWithDefault
                          src={row.brandImage}
                          style={{ width: "180px", height: "100px", objectFit: "contain" }}
                        />
                        <span>
                          {row.brandName}
                          <span></span>
                        </span>
                      </Link>
                    </div>
                  </div>
                </CSSTransition>
              ))
            ) : objectRef?.current ? (
              <CSSTransition key={-1} timeout={500} classNames="fade">
                <div className="container d-flex mt-12 mt-lg-4">
                  <div style={{ margin: "auto" }}>No Result Found</div>
                </div>
              </CSSTransition>
            ) : (
              <CSSTransition key={0} timeout={500} classNames="fade">
                <BrandSkeleton count={4} />
              </CSSTransition>
            )}
          </TransitionGroup>
        </div>
      </section>
    </Fragment>
  );
};
